// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3r1JY","addWidgetButton":"Header_addWidgetButton__3Ti06","dashboardTabs":"Header_dashboardTabs__iJZbE","active":"Header_active__U1BSs"};